export function getConnectedUser() {
  const strUser = localStorage.getItem("user");
  return JSON.parse(strUser);
}
